import React, { useEffect, useState } from 'react'
import { useGetQuery } from '../api/index.js'
import { styled } from '@pergas-common/pergas-components'

const SelectHolder = styled.div`
  width: 100%;
  margin: 8px 0;
  position: relative;
  display: flex;
  flex-direction: column-reverse;
  > span {
    margin-left: 8px;
    ${({ theme }) => theme.typography.breadcrumb}
    color: #3a4a54;
  }
`

const Select = styled.select`
  width: 100%;
  padding: 8px;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  &:focus {
    border-color: #007bff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
`

const Option = styled.option`
  padding: 8px;
  background-color: #fff;
  color: #000;
  &:hover {
    background-color: #f0f0f0;
  }
`

const ContentTypeDropdown = ({ disabled, selected: selectedProp, onChangeInput }) => {
  const [selected, setSelected] = useState(selectedProp)
  const { data = [] } = useGetQuery('content-type', [{ key: 'field_internal_name', op: '=', value: 'pdscol_document_class' }])

  const choices = (data && data[0]?.field_blob?.choice?.choices) || []

  useEffect(() => {
    setSelected(selectedProp)
    onChangeInput(selectedProp)
  }, [selectedProp])

  return (
    <SelectHolder>
      <Select
        disabled={disabled} value={selected || ''} onChange={(event) => {
          setSelected(event.target.value)
          onChangeInput(event.target.value)
        }}
      >
        <Option value=''>Välj dokumenttyp</Option>
        {choices && choices.map((choice, index) => (
          <Option key={`${choice}-${index}`} value={choice}>{choice}</Option>
        ))}
      </Select>
    </SelectHolder>
  )
}

export default ContentTypeDropdown
